import React from 'react';
import block from 'bem-cn';
import { useDispatch } from 'react-redux';
import Button from 'components/Button';
import dayjs from 'dayjs';
import { actions } from 'features/creativeFunctionality/redux';
import { customRequestStatusesEnums } from 'features/creativeFunctionality/models/customRequestsModel/data';

import './CustomPageTableRow.scss';

const b = block('custom-page-table-row');

const CustomPageTableRow = ({ item, locale, handleDetails, handleSearch }) => {
  const dispatch = useDispatch();

  const showButtons =
    item.status !== customRequestStatusesEnums.approved && item.status !== customRequestStatusesEnums.rejected;

  return (
    <div className={b('tr')}>
      <div className={b('td')}>
        <span className={b('td-text')}>{locale[item.type] || item.type}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-text')}>{item.agentId}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-text')}>{item.username}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-text', { type: 'structure' })}>{item.structure}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-text')}>{item.netwin}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-text')}>{dayjs(item.createdAt).format('DD/MM/YY')}</span>
      </div>
      <div className={b('td')}>
        <span onClick={() => handleDetails(item.id)} className={b('td-text', { type: 'details' })}>
          {locale.details}
        </span>
      </div>
      <div className={b('td')}>
        <span className={b('td-text')}>{locale.customRequestStatuses[item.status]}</span>
      </div>
      <div className={b('td')}>
        {showButtons && (
          <div className={b('buttons')}>
            <div className={b('button')}>
              <Button
                color="green"
                text={locale.confirm}
                callBack={() => dispatch(actions.approveCustomRequest({ id: item.id, approve: true }, handleSearch))}
              />
            </div>
            <div className={b('button')}>
              <Button
                color="red"
                text={locale.reject}
                callBack={() => dispatch(actions.approveCustomRequest({ id: item.id, approve: false }, handleSearch))}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomPageTableRow;
